/**
 * Asynchronously loads the component for PiecripRewardsHubPage
 */

import { lazyLoad } from '@utils/loadable';

export const PiecripRewardsHubPage = lazyLoad(
  () => import('./index'),
  (module) => module.PiecripRewardsHubPage
);
